/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { FeedbackService, FeedbackType } from './FeedbackService'

declare let OfficeFirstParty: any
declare let OfficeCore: any

export default class OCVFeedbackService extends FeedbackService {
    constructor(feedbackStartedCallback: (type: FeedbackType) => void | undefined) {
        super(feedbackStartedCallback)
    }

    public CollectFeedback(type: FeedbackType, componentName: string) {
        let ocvType: any | undefined
        switch (type) {
            case FeedbackType.Like: {
                ocvType = OfficeCore.UserFeedbackType.like
                break
            }
            case FeedbackType.Dislike: {
                ocvType = OfficeCore.UserFeedbackType.dislike
                break
            }
            default:
                break
        }

        if (ocvType != undefined) {
            const v2Config = {
                isFileUploadEnabled: OfficeCore.TriStateOption.false,
                isScreenshotEnabled: OfficeCore.TriStateOption.true,
                isEmailCollectionEnabled: OfficeCore.TriStateOption.true
            }

            OfficeFirstParty.UserFeedback.CollectUserFeedback(
                ocvType,
                OfficeCore.UserFeedbackUIType.modalDialog,
                componentName,
                { v2Config }
            )

            this.feedbackStartedCallback && this.feedbackStartedCallback(type)
        }
    }
}